/*
 * Configuration for axios.
 */
const axiosConfig = {
  xsrfCookieName: "csrf-token",
  xsrfHeaderName: "x-csrf-token",
};

export default axiosConfig;
